import { ReportTypes } from "@/app/reports/utils/enums";
import { StrategyType } from "@/app/shared/utils/enums";
import httpManager from "@/app/shared/utils/httpManager";

export interface DownloadDto {
  entity: number;
  portfolio: number;
  startDate: string;
  endDate: string;
  strategyType: (typeof StrategyType)[keyof typeof StrategyType];
}

class StrategiesReport {
  private baseUrl = `/reports/${ReportTypes.Strategies}/download`;

  private getDatesParam(dates: string[]) {
    const startDate = `${dates.at(0)} 00:00:00`;
    const endDate = `${dates.at(1)} 23:59:59`;

    return `start_date=${startDate}&end_date=${endDate}`;
  }

  async download(downloadDto: DownloadDto) {
    const { startDate, endDate, entity, portfolio, strategyType } = downloadDto;

    const datesQuery = this.getDatesParam([startDate, endDate]);

    const url = `${this.baseUrl}/?${datesQuery}&portfolio=${portfolio}&strategy_type=${strategyType}&entity=${entity}`;

    const response = await httpManager.post(url, {}, { blob: true });

    return response;
  }
}

export const strategiesReportService = new StrategiesReport();
